export enum SeriationStatus {
  ASSIGNED = 'assigned',
  AUTOMATIC = 'automatic',
  NOTASSIGNED = 'notAssigned',
  NOTASSIGNED_MANDATORY = 'notAssignedMandatory',
  PROBABLY_ASSIGNED = 'probably_assigned',
  PROBABLY_NOTASSIGNED = 'probably_notAssigned',
}
